module.exports = __webpack_public_path__ + "img/relation_shape1.83f502a.svg";